import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import n from "../../../Color.js";
import { JSONSupport as t } from "../../../core/JSONSupport.js";
import { property as i } from "../../../core/accessorSupport/decorators/property.js";
import { subclass as o } from "../../../core/accessorSupport/decorators/subclass.js";

var r = /*#__PURE__*/function (_t) {
  _inherits(r, _t);

  var _super = _createSuper(r);

  function r() {
    var _this;

    _classCallCheck(this, r);

    _this = _super.apply(this, arguments), _this.enabled = !0;
    return _this;
  }

  return r;
}(t);

e([i({
  type: Boolean
})], r.prototype, "enabled", void 0), r = e([o("esri.views.interactive.snapping.Settings.DefaultSnappingAlgorithm")], r);

var l = /*#__PURE__*/function (_t2) {
  _inherits(l, _t2);

  var _super2 = _createSuper(l);

  function l(e) {
    var _this2;

    _classCallCheck(this, l);

    _this2 = _super2.call(this, e), _this2.lineSnapper = new r(), _this2.parallelLineSnapper = new r(), _this2.rightAngleSnapper = new r(), _this2.rightAngleTriangleSnapper = new r(), _this2.shortLineThreshold = 15, _this2.distance = 5, _this2.pointThreshold = 1e-6, _this2.intersectionParallelLineThreshold = 1e-6, _this2.parallelLineThreshold = 1e-6, _this2.touchSensitivityMultiplier = 1.5, _this2.pointOnLineThreshold = 1e-6, _this2.orange = new n([255, 127, 0]), _this2.lineHintWidthReference = 3, _this2.lineHintWidthTarget = 3, _this2.lineHintFadedExtensions = .3, _this2.parallelLineHintWidth = 2, _this2.parallelLineHintLength = 24, _this2.parallelLineHintOffset = 1.5, _this2.rightAngleHintSize = 24, _this2.rightAngleHintOutlineSize = 1.5;
    return _this2;
  }

  return l;
}(t);

e([i({
  type: r,
  constructOnly: !0,
  nonNullable: !0,
  json: {
    write: !0
  }
})], l.prototype, "lineSnapper", void 0), e([i({
  type: r,
  constructOnly: !0,
  nonNullable: !0,
  json: {
    write: !0
  }
})], l.prototype, "parallelLineSnapper", void 0), e([i({
  type: r,
  constructOnly: !0,
  nonNullable: !0,
  json: {
    write: !0
  }
})], l.prototype, "rightAngleSnapper", void 0), e([i({
  type: r,
  constructOnly: !0,
  nonNullable: !0,
  json: {
    write: !0
  }
})], l.prototype, "rightAngleTriangleSnapper", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: -1,
    max: 50,
    step: 1
  },
  json: {
    write: !0
  }
})], l.prototype, "shortLineThreshold", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: -1,
    max: 50,
    step: 1
  },
  json: {
    write: !0
  }
})], l.prototype, "distance", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 1e-5
  },
  json: {
    write: !0
  }
})], l.prototype, "pointThreshold", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 1e-5
  },
  json: {
    write: !0
  }
})], l.prototype, "intersectionParallelLineThreshold", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 1e-5
  },
  json: {
    write: !0
  }
})], l.prototype, "parallelLineThreshold", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 10
  },
  json: {
    write: !0
  }
})], l.prototype, "touchSensitivityMultiplier", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 1e-5
  },
  json: {
    write: !0
  }
})], l.prototype, "pointOnLineThreshold", void 0), e([i({
  type: n,
  nonNullable: !0
})], l.prototype, "orange", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 10
  },
  json: {
    write: !0
  }
})], l.prototype, "lineHintWidthReference", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 10
  },
  json: {
    write: !0
  }
})], l.prototype, "lineHintWidthTarget", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 1
  },
  json: {
    write: !0
  }
})], l.prototype, "lineHintFadedExtensions", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 10
  },
  json: {
    write: !0
  }
})], l.prototype, "parallelLineHintWidth", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 50
  },
  json: {
    write: !0
  }
})], l.prototype, "parallelLineHintLength", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 5
  },
  json: {
    write: !0
  }
})], l.prototype, "parallelLineHintOffset", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 46
  },
  json: {
    write: !0
  }
})], l.prototype, "rightAngleHintSize", void 0), e([i({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 6
  },
  json: {
    write: !0
  }
})], l.prototype, "rightAngleHintOutlineSize", void 0), l = e([o("esri.views.interactive.snapping.Settings.Defaults")], l);
var p = new l();
export { p as defaults };